<template>
  <el-dialog
    :close-on-click-modal="false"
    title="核销账单"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
  >
    <section v-loading="getDetailLoading">
      <qx-card-form
        :title="'账单' + (index + 1)"
        v-for="(item, index) in writeOffListData"
        :key="item.checkId"
      >
        <span slot="titleLeft">
          <span
            class="primary cur writeOffBtn"
            v-show="originData.billSts !== 1 && (index === writeOffListData.length -1)"
            @click="add(index)"
          >添加</span>
          <span
            class="error cur writeOffBtn"
            v-show="writeOffListData.length > 1 && originData.billSts !== 1 && !item.checkId"
            @click="del(index)"
          >删除</span>
        </span>
        <WriteOffForm
          ref="writeOffForm"
          :originFormData="item"
          :checkTypeOptions="checkTypeOptions"
          :accountNameOptions="accountNameOptions"
          :disabled="!!item.checkId"
        />
      </qx-card-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button
        v-show="originData.billSts !== 1"
        type="primary"
        @click="sub"
        :loading="subLoading || getDetailLoading"
      >确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  customerBillWriteOffList,
  customerBillWriteOffEdit, companyBankcardList,
} from 'api/getPay';
import WriteOffForm from './writeOffForm';
import {
  getEnumList,
} from 'api';
import {mapState} from 'vuex';
import {formatDateTimeSecond} from '@qx/utils';
import {saveSearch} from '@qx/utils/cache';
export default {
  components: {
    WriteOffForm,
  },
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      originData: {},
      writeOffListData: [],
      checkTypeOptions: [],
      accountNameOptions: [],
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    async show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.originData = item;
      this.getDetailLoading = true;
      const listRes = await customerBillWriteOffList({
        billNumber: item.billNumber,
      });
      this.getDetailLoading = false;
      if (!listRes.failed) {
        if (listRes.items.length === 0) {
          listRes.items = [{
            checkType: '',
            accountName: '',
            accountType: '',
            transactionTime: formatDateTimeSecond(new Date()),
            oppositeAccountName: '',
            oppositeAccountNumber: '',
            checkFeeDouble: '',
            checkDesc: '',
            checkId: 0,
          }];
        }
        this.writeOffListData = listRes.items.map((item) => {
          item.checkType = String(item.checkType);
          return item;
        });
      }
    },
    add (index) {
      // 主卡卡号（输入匹配）、冲抵金额（输入数字）、余额（自动更新）
      this.writeOffListData.splice(index + 1, 0, {
        checkType: '',
        accountName: '',
        accountType: '',
        transactionTime: '',
        oppositeAccountName: '',
        oppositeAccountNumber: '',
        checkFeeDouble: '',
        checkDesc: '',
        checkId: 0,
        masterCardNo: '',
        chargeAgainstMoney: 0,
        balance: 0,
      });
    },
    del (index) {
      this.writeOffListData.splice(index, 1);
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      const checkDatas = [];
      for (let i = 0; i < this.$refs.writeOffForm.length; i++) {
        const subData = await this.$refs.writeOffForm[i].sub();
        if (subData) {
          checkDatas.push(subData);
        } else {
          return;
        }
      }
      this.subLoading = true;
      const res = await customerBillWriteOffEdit({
        checkDatas: JSON.stringify(checkDatas),
        billNumber: this.originData.billNumber,
      });

      this.subLoading = false;
      if (!res.failed) {
        const userId = this.userInfo.staffTFInfo.userId;
        checkDatas.map((item) => {
          if (item.oppositeAccountNumber) {
            saveSearch(`${userId}_opAcctNum`, item.oppositeAccountNumber); // 本地存储搜索的内容
          }
          if (item.oppositeAccountName) {
            saveSearch(`${userId}_opAcctName`, item.oppositeAccountName); // 本地存储搜索的内容
          }
        });
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '保存成功',
        });
        this.$emit('sub');
      }
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'CHECK_TYPE',
    });
    this.checkTypeOptions = enumsList[0];

    const accountRes = await companyBankcardList(); // 账户名称列表
    let priObj = {};
    if (accountRes.allPriAcct.length > 0) {
      priObj = accountRes.allPriAcct.map((item) => ({
        label: item.acctNameAcctNo,
        value: item.acctNo,
        accountType: item.bankType, // 账户类型
        bankCardNo: item.acctNo, // 银行卡号
        balance: item.balance, // 账户余额
        accountName: item.acctName, // 账户名称
      }));
      this.accountNameOptions.push(...priObj);
    }
    let pubObj = {};
    if (accountRes.allPubAcct.length > 0) {
      pubObj = accountRes.allPubAcct.map((item) => ({
        label: item.acctNameAcctNo,
        value: item.acctNo,
        accountType: item.bankType, // 账户类型
        bankCardNo: item.acctNo, // 银行卡号
        balance: item.balance, // 账户余额
        accountName: item.acctName, // 账户名称
      }));
      this.accountNameOptions.push(...pubObj);
    }
  },
};
</script>

<style scoped lang="scss">
.writeOffBtn {
  margin-left: 16px;
}
</style>
